import { Button, Grid } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { autorizarReservaAction, obtenerReservasAction } from "./../../../ducks/reservasDuck"
import { useState } from "react"
import { ToastMessage } from "../../../global/ToastMessage"
import BackDrop from "../../../global/BackDrop"
import { DialogMessage } from "../../../global/DialogMessage"
import { FAutorizarStyle } from "./styles"
import { formatDinero } from "./../../../utils/formatDinero"
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import { EstatusCompra } from "../../../constant/catEstatusCompra"
const ModalMensaje = (props) => {
    const { Compra, Moneda, open = false, setOpen = () => { }, estatus = 0 } = props
    const dispatch = useDispatch()
    const classes = FAutorizarStyle()
    const [load, setLoad] = useState(false)
    const handleClose = () => {
        setOpen(false)
    }
    const onGuardar = () => {
        DialogMessage.fire({
            title: `¿Esta seguro de mandar al area de finanazas
            la solicitud de pago de este Item?`,
            html: (estatus === EstatusCompra.FONDOS_INSUFICIENTES) ? `Los fondos no son suficientes para cubrir toda la reserva. </br> ¿Desea continuar con el proceso?`: "",
            showCancelButton: true,
            confirmButtonText: "Aplicar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(autorizarReservaAction({ idCompra: Compra.idCompra })).then(Response => {
                    if (Response.status || Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                        });
                        setLoad(false)
                        return null
                    }
                    ToastMessage.fire({
                        icon: "success",
                        title: "Operación exitoasa",
                    })
                    dispatch(obtenerReservasAction())
                    setLoad(false)
                })
            }
        })
    }
    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo="Solicitar Pago de Item"
            />
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12}>
                    <div style={{ margin: '10px' }}>
                        <p>Motivo: <b>Reserva</b></p>
                        <p>Monto pagado: <b>{formatDinero(Compra?.MontoProveedor)} {Moneda?.Clave}</b></p>
                    </div>
                </Grid>
            </Grid>
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} className={classes.modalBotonesCenter}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.modalBoton}
                        onClick={onGuardar}
                    >
                        Aplicar
                    </Button>
                </Grid>
            </Grid>
            <BackDrop open={load} />
        </ModalBase>
    )
}

const FAutorizacion = (props) => {
    const { Compra, disabled = false, Moneda, estatus = 0 } = props
    const [open, setOpen] = useState(false)
    const onOpen = () => {
        setOpen(true)
    }
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={onOpen} disabled={disabled}>
                Enviar finanzas
            </Button>
            <ModalMensaje open={open} Moneda={Moneda} setOpen={setOpen} Compra={Compra} estatus={estatus} />
        </div>

    )
}
export default FAutorizacion